'use strict'

import loginButton from './loginButton.vue'
import adminButton from './adminButton.vue'
import helpButton from 'Common/components/help-button.vue'

function components (Vue, options) {
	// Other components
	Vue.component('login-button', loginButton)
	Vue.component('admin-button', adminButton)
	Vue.component('help-button', helpButton)
}

export default components



// WEBPACK FOOTER //
// ./src/components/index.js